module.exports = __webpack_public_path__ + "static/media/park.e3fc65d3.png";